// tracking/TrackingProvider.jsx
import React, { useEffect, useCallback, useMemo } from "react";
import TagManager from "react-gtm-module";
import { TrackingContext } from "./TrackingContext";

export function TrackingProvider({ children }) {
  const GTM_ID = import.meta.env.VITE_GTM_ID || "GTM-XXXXXXX";
  useEffect(() => {
    try {
      TagManager.initialize({ gtmId: GTM_ID });
      if (typeof window !== "undefined") {
        window.dataLayer = window.dataLayer || [];
      }
    } catch (e) {
      if (import.meta.env.DEV) console.error("GTM init failed", e);
    }
  }, [GTM_ID]);

  const trackEvent = useCallback((name, params = {}) => {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    const payload = { event: "app_event", event_name: name, ...params };
    window.dataLayer.push(payload);
    if (import.meta.env.DEV) console.debug("Tracked event:", payload);
  }, []);

  const value = useMemo(() => ({ trackEvent }), [trackEvent]);

  return (
    <TrackingContext.Provider value={value}>
      {children}
    </TrackingContext.Provider>
  );
}
